goog.provide('el8.ptdata.plrCollaboratorNotifications');

goog.require('el8.data.referencedUsers');
goog.require('el8.model.base');
goog.require('el8.service.urls');


/**
 * Notifications that someone else has joined our list of PLR collaborators
 * for a patient ("breaking the seal" when they gain access to our data)
 */
el8.ptdata.plrCollaboratorNotifications = (function() {

    var _class = function(spec) {
        this.populate(spec);
    };
    _class.inheritsFrom(el8_Entity);
    _class.makeDocument();

    _class.addIntProperty('collaboratingPracticeId');
    _class.addIntProperty('collaboratingUserId');
    _class.addIntProperty('initiatingUserId');
    _class.addStringProperty('collaboratingUserName');
    _class.addStringProperty('initiatingUserName');
    _class.addIntProperty('careTeamInviteId');
    _class.addStringProperty('eventType');
    _class.addBoolean('careTeamRelated');

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        deleteFn: function(var_args) { return el8.ptdata.documentDeleteFn.apply(that, arguments); }
    });

    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);

        mapped['collaboratorIsCurrentUser'] = (this.getCollaboratingUserId() === el8.data.currUser.getId());
        mapped['initiatingIsCurrentUser'] = (this.getInitiatingUserId() === el8.data.currUser.getId());
        mapped['enterpriseName'] = el8.data.currPractice.getEnterpriseName();

        return mapped;
    };

    _class.prototype.acknowledge = function(successCb) {
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('acknowledgePlrCollabNotification', [this.getPatientId(), this.getId()]),
            success: function(data) {
                that.create(data);
                if (successCb) { successCb(); }
            }
        });
    };

    return that;

})();
